import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import user, { TVODPurchaseOption } from '../../../helpers/user';
import { __ } from '../../../translations';
import { TVODOverlayType } from './TVODOverlay';
import { tvodForgetPasswordApi } from '../../../services/serviceWrapper/tvodServiceWrapper';
import { PPV_PURCHASE_OPTIONS } from '@intigral/constant';
import { useConfigurationSections } from '../../../hooks/useConfiguration';

const AlternativePaymentLinksPPV = ({ onSelected, currentOverlayType }) => {
    const [forgetPasswordLoader, setForgetPasswordLoader] = useState(false);
    const [forgetPasswordToaster, setForgetPasswordToaster] = useState(false);
    const [forgetPasswordMsisdn, setForgetPasswordMsisdn] = useState('');

    // Using React Query instead of Redux for configuration
    const { tvodConfig } = useConfigurationSections();
    const forgetPasswordSegments = tvodConfig?.forgetPasswordSegments;
    const forgetPasswordSegmentsExcludeOperators = tvodConfig?.excludeOperators;

    const userInfo = user.getUserInfo();
    const operator = userInfo?.operator;
    const alternativeOptions = [user.getPPVPurchaseOption(operator), ...user.getPPVAlternativePaymentMethods(operator)];
    const subscribeByPin =
        alternativeOptions.indexOf(PPV_PURCHASE_OPTIONS.PIN) > -1 && currentOverlayType !== PPV_PURCHASE_OPTIONS.PIN;
    const subscribeByPassword =
        alternativeOptions.indexOf(PPV_PURCHASE_OPTIONS.PASSWORD) > -1 &&
        currentOverlayType !== PPV_PURCHASE_OPTIONS.PASSWORD;
    const subscribeByOTP =
        alternativeOptions.indexOf(PPV_PURCHASE_OPTIONS.OTP) > -1 && currentOverlayType !== PPV_PURCHASE_OPTIONS.OTP;

    const forgetPasswordFunc = async () => {
        setForgetPasswordLoader(true);
        const response = await tvodForgetPasswordApi();
        // const response = await apis.getJawwyService().getTVODService().forgetPassword();
        setForgetPasswordMsisdn(response?.msisdn ?? '');
        setForgetPasswordLoader(false);
        setForgetPasswordToaster(true);
        setTimeout(() => {
            setForgetPasswordToaster(false);
        }, 3000);
    };

    const SuccessMesage = ({ message }) => {
        return (
            <div className="qitaf-snackbar" style={{ zIndex: 999999 }}>
                <div>
                    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M22.249 33.9355L36.6855 18.6969L34.669 16.7865L22.1952 29.9533L15.9721 23.7302L14.0079 25.6944L22.249 33.9355Z"
                            fill="white"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M44.4444 25C44.4444 35.7389 35.7389 44.4444 25 44.4444C14.2611 44.4444 5.55554 35.7389 5.55554 25C5.55554 14.2611 14.2611 5.55554 25 5.55554C35.7389 5.55554 44.4444 14.2611 44.4444 25ZM41.6666 25C41.6666 34.2047 34.2047 41.6666 25 41.6666C15.7952 41.6666 8.33332 34.2047 8.33332 25C8.33332 15.7952 15.7952 8.33332 25 8.33332C34.2047 8.33332 41.6666 15.7952 41.6666 25Z"
                            fill="white"
                        />
                    </svg>
                    <span>{message}</span>
                </div>
            </div>
        );
    };

    return (
        <>
            {forgetPasswordToaster && (
                <SuccessMesage
                    message={__('tvod_password_forget_successfully').replace('{msisdn}', forgetPasswordMsisdn)}
                />
            )}
            {subscribeByPin && (
                <div className="help-text center">
                    <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            onSelected(TVODOverlayType.PIN);
                        }}
                    >
                        {__('tvod_subscribe_by_pin')}
                    </a>
                </div>
            )}
            {subscribeByPassword && (
                <div className="help-text center">
                    <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            onSelected(TVODOverlayType.PASSWORD);
                        }}
                    >
                        {__('tvod_subscribe_by_password')}
                    </a>
                </div>
            )}
            {subscribeByOTP && (
                <div className="help-text center">
                    <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            onSelected(TVODOverlayType.OTP);
                        }}
                    >
                        {__('tvod_subscribe_by_otp')}
                    </a>
                </div>
            )}

            {forgetPasswordSegments &&
                forgetPasswordSegmentsExcludeOperators &&
                !forgetPasswordSegmentsExcludeOperators.includes(operator) &&
                forgetPasswordSegments.includes(user.getUserSegment().toLowerCase()) && (
                    <div className="help-text center">
                        <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                forgetPasswordFunc();
                            }}
                        >
                            {!forgetPasswordLoader && __('tvod_forget_password')}
                        </a>
                    </div>
                )}
        </>
    );
};

export default AlternativePaymentLinksPPV;
